import React from "react";
import { Button, Card, Col, Label } from "reactstrap";
import { Field, Form, Formik } from "formik";
import DatePicker from "react-datepicker";
import ReactSelect from "react-select";
import moment from "moment";
import { crossIcon } from "../../../constant/icons";
import { UnMountingStatusFilterDropDown } from "../../unMounting/mobileView/components/filter";

// Define types for props
interface LandloardFilterProps {
    filterValues: {
        name?: string[];
        fromDate?: string | null;
        toDate?: string | null;
    };
    setFilterValues: (values: any) => void;
    onCloseFilter: () => void;
    landloardApiDataList: { value: string; label: string }[];
}

export const LandloardReportFilter: React.FC<LandloardFilterProps> = ({
    filterValues = {},
    setFilterValues,
    onCloseFilter,
    landloardApiDataList = [],
}) => {

    // Formik's onSubmit handler
    const handleSubmit = (values: any) => {
        setFilterValues({
            ...values,
            fromDate: values.fromDate ? moment(values.fromDate).format('DD-MM-YYYY') : null,
            toDate: values.toDate ? moment(values.toDate).format('DD-MM-YYYY') : null,
        });
        onCloseFilter();
    };

    return (
        <Card className="filter-box">
            <div className="d-flex justify-content-between">
                <h3>Filters</h3>
                <Button className="cancel_filter" color="link" onClick={onCloseFilter}>
                    {crossIcon.icon}
                </Button>
            </div>
            <Formik
                initialValues={{
                    name: filterValues.name || [],
                    fromDate: filterValues.fromDate ? moment(filterValues.fromDate, "DD-MM-YYYY").toDate() : null,
                    toDate: filterValues.toDate ? moment(filterValues.toDate, "DD-MM-YYYY").toDate() : null,
                }}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ setFieldValue, values }) => (
                    <Form className="form-row">
                        <Col md={3} className="mb-3">
                            <Label htmlFor="name">Landloard Name</Label>
                            <ReactSelect
                                name="name"
                                onChange={(selectedOptions: any) => {
                                    const selectedValues = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];
                                    setFieldValue("name", selectedValues);
                                }}
                                isMulti
                                options={landloardApiDataList}
                                value={landloardApiDataList.filter((option: any) => values.name.includes(option.value))}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Label className="form-label">From Available Date</Label>
                            <Field
                                component={DatePicker}
                                placeholderText={"DD/MM/YYYY"}
                                dateFormat={"dd/MM/yyyy"}
                                className="form-control"
                                menuPortalTarget={document.body}
                                selected={values.fromDate}
                                onChange={(selectedDate: any) => {
                                    setFieldValue("fromDate", selectedDate);
                                }}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Label className="form-label">To Available Date</Label>
                            <Field
                                component={DatePicker}
                                placeholderText={"DD/MM/YYYY"}
                                dateFormat={"dd/MM/yyyy"}
                                className="form-control"
                                menuPortalTarget={document.body}
                                selected={values.toDate}
                                onChange={(selectedDate: any) => {
                                    setFieldValue("toDate", selectedDate);
                                }}
                            />
                        </Col>
                        <Col md={12} className="mt-3">
                            <Button type="submit" color="primary">Apply Filters</Button>
                        </Col>
                    </Form>
                )}
            </Formik>
        </Card>
    );
};
